import { useColors } from '../../hooks/useColors'

type Props = { formData: Record<string, string>; onChange: (key: string, value: string) => void }

export default function SlotSettingsTab({ formData, onChange }: Props) {
  const colors = useColors()
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <h3 style={{ margin: 0, color: colors.textPrimary }}>Slot Settings</h3>
      <input value={formData.express_slot_max_workload || ''} onChange={(e) => onChange('express_slot_max_workload', e.target.value)} placeholder="Express Slot Max Workload" />
      <input value={formData.express_operating_start_hour || ''} onChange={(e) => onChange('express_operating_start_hour', e.target.value)} placeholder="Express Start Hour" />
      <input value={formData.express_operating_end_hour || ''} onChange={(e) => onChange('express_operating_end_hour', e.target.value)} placeholder="Express End Hour" />
      <input value={formData.express_min_lead_minutes || ''} onChange={(e) => onChange('express_min_lead_minutes', e.target.value)} placeholder="Express Min Lead Minutes" />
      <input value={formData.express_base_minutes || ''} onChange={(e) => onChange('express_base_minutes', e.target.value)} placeholder="Express Base Minutes" />
      <label style={{ color: colors.textPrimary }}>
        <input type="checkbox" checked={String(formData.express_service_enabled) === 'true'} onChange={(e) => onChange('express_service_enabled', e.target.checked ? 'true' : 'false')} /> Express Service Enabled
      </label>
    </div>
  )
}
